var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnseen = function SvgUnseen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "m4 8.503 6-4.444 6 4.444v1.481l-4.953 3.672a1.772 1.772 0 0 1-2.094 0L4 9.984zM10 2c-.378 0-.744.122-1.047.344L2.81 6.897C2.3 7.275 2 7.869 2 8.503V16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V8.503c0-.634-.3-1.231-.81-1.606l-6.143-4.553A1.77 1.77 0 0 0 10 2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnseen);
export default ForwardRef;